import React from 'react';

const ChildrenAgeRangesFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.5 1.5V3.16667" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.83335 1.5V3.16667" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.5 5.66667H14.8333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M14.8333 8.00006V4.00004C14.8333 3.07921 14.0875 2.33337 13.1667 2.33337H3.16667C2.24583 2.33337 1.5 3.07921 1.5 4.00004V13.1667C1.5 14.0875 2.24583 14.8334 3.16667 14.8334H8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.83252 7.95833C4.71752 7.95833 4.62419 8.05167 4.62502 8.16667C4.62502 8.28167 4.71836 8.375 4.83336 8.375C4.94836 8.375 5.04169 8.28167 5.04169 8.16667C5.04169 8.05167 4.94836 7.95833 4.83252 7.95833"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.83252 7.95833C7.71752 7.95833 7.62419 8.05167 7.62502 8.16667C7.62502 8.28167 7.71836 8.375 7.83336 8.375C7.94836 8.375 8.04169 8.28167 8.04169 8.16667C8.04169 8.05167 7.94836 7.95833 7.83252 7.95833"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.83252 11.2917C4.71752 11.2917 4.62419 11.385 4.62502 11.5C4.62502 11.615 4.71836 11.7084 4.83336 11.7084C4.94836 11.7084 5.04169 11.615 5.04169 11.5C5.04169 11.385 4.94836 11.2917 4.83252 11.2917"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_1398_980)">
      <path
        d="M13 18C15.7614 18 18 15.7614 18 13C18 10.2386 15.7614 8 13 8C10.2386 8 8 10.2386 8 13C8 15.7614 10.2386 18 13 18Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 14C11 14 11.75 15 13 15C14.25 15 15 14 15 14"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.5 11.8333H11.506" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 11.8333H14.506" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1398_980">
        <rect width="12" height="12" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
);

export default ChildrenAgeRangesFilterIcon;
